import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatAngularModule } from '../../shared/modules/mat-angular.module';
import { Router, RouterModule } from '@angular/router';
import { AuthService, User } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProjectManagementService } from '../../services/project-management.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { GlobalLoaderComponent } from '../../shared/global-loader/global-loader.component';

@Component({
  selector: 'app-generic-dashboard',
  imports: [
    CommonModule,
    MatAngularModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    // GlobalLoaderComponent
  ],
  templateUrl: './generic-dashboard.component.html',
  styleUrl: './generic-dashboard.component.scss',
  standalone: true,
})
export class GenericDashboardComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  snackBar = inject(MatSnackBar);
  projectService = inject(ProjectManagementService);
  http = inject(HttpClient);

  isLoading = false;
  currentUser: User | null = null;
  analysesCompleted = 0;
  reportsGenerated = 0;
  insightsDiscovered = 0;

  ngOnInit() {
    this.loadUserProfile();
    this.loadDashboardStats();
  }

  private loadUserProfile() {
    this.currentUser = this.authService.getCurrentUser();
    if (!this.currentUser) {
      this.router.navigate(['/login']);
      return;
    }
    this.isLoading = false;
  }

  private loadDashboardStats() {
    // Load all projects to calculate stats
    this.projectService.getAllProjects(0, 1000).subscribe({
      next: (response) => {
        // Analyses Completed: total projectdata count
        this.analysesCompleted = response.projects.reduce((sum, p) => sum + (p.projectdata_count || 0), 0);
        
        // Reports Generated: total charts × projectdata count
        // Assuming ~10 charts per analysis (one per tab)
        const chartsPerAnalysis = 10;
        this.reportsGenerated = this.analysesCompleted * chartsPerAnalysis;
        
        // Insights Discovered: Set to 0 (removed discovery pages API call)
        this.insightsDiscovered = 0;
      },
      error: () => {
        // Set defaults on error
        this.analysesCompleted = 0;
        this.reportsGenerated = 0;
        this.insightsDiscovered = 0;
      }
    });
  }

  navigateToBrandAnalysis(type: string): void {
    if (type === 'brand-analysis') {
      this.router.navigate(['/brand-analysis']);
    } else if (type === 'competitive-intelligence') {
      this.router.navigate(['/brand-analysis']);
    }
  }
}

